<div [ngClass]="wrapperClass">
<dialog id-mobile-message-modal>
	<ng-container [ngSwitch]="modalType">
		<ng-container *ngSwitchDefault>
			<ng-container *ngTemplateOutlet="defaultTemplate"></ng-container>
		</ng-container>
		<ng-container *ngSwitchCase="ModalType.CUSTOM">
			<ng-container *ngTemplateOutlet="customTemplate"></ng-container>
		</ng-container>
	</ng-container>
</dialog>
</div>


<ng-template #defaultTemplate>
	<div class="bg-[#F5F5F5] min-h-screen">
		<div class="flex flex-col justify-end min-h-screen px-[20px]">
			<div>
				<div class="mx-[20px]">
					<ng-container *ngTemplateOutlet="body"></ng-container>
				</div>
				<div class="pt-44">
					<ng-container *ngTemplateOutlet="footer"></ng-container>
				</div>
			</div>
		</div>
	</div>
</ng-template>
<ng-template #customTemplate>
	<ng-container *ngIf="isFullScreen else defaultCustomTemplate">
    <ng-container *ngTemplateOutlet="fullScreenCustomTemplate"></ng-container>
  </ng-container>
</ng-template>

<ng-template #fullScreenCustomTemplate>
  <ng-container *ngTemplateOutlet="customTemplateContent"></ng-container>
</ng-template>

<ng-template #defaultCustomTemplate>
  <div class="bg-black/50 min-h-screen flex flex-col justify-end">
    <div class="flex flex-col gap-[8px]">
      <div class="flex justify-center">
        <svg width="59" height="4" viewBox="0 0 59 4" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="59" height="4" rx="2" fill="white" fill-opacity="0.5"/>
        </svg>
      </div>
      <div class="bg-white rounded-t-[24px] pt-[32px] pb-[48px] px-[20px]">
        <ng-container *ngTemplateOutlet="customTemplateContent"></ng-container>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #customTemplateContent>
  <ng-content></ng-content>
</ng-template>

<ng-template #body>
	<div class="py-14 flex flex-col justify-center items-center">
		<div>
			<ng-container [ngSwitch]="iconType">
				<ng-container *ngSwitchDefault>
					<ng-container *ngTemplateOutlet="infoIcon"></ng-container>
				</ng-container>
        <ng-container *ngSwitchCase="IconType.WARNING">
          <ng-container *ngTemplateOutlet="warningIcon"></ng-container>
        </ng-container>
				<ng-container *ngSwitchCase="IconType.ERROR">
					<ng-container *ngTemplateOutlet="errorIcon"></ng-container>
				</ng-container>
				<ng-container *ngSwitchCase="IconType.SUCCESS">
					<ng-container *ngTemplateOutlet="successIcon"></ng-container>
				</ng-container>
			</ng-container>
		</div>
		<div class="max-w-[335px] mx-auto text-center">
			<div class="pt-[32px]">
				<div class="text-[32px] leading-[39.68px] font-bold text-black">
					{{title}}
				</div>
			</div>
			<div class="pt-[12px]">
        <div *ngIf="btnType === BtnType.LOADING" class="relative top-[30px]">
        <div  class="vertically-centralized">
          <app-kamona-loading [loadingText]="description" loadingType="SPINNER">
          </app-kamona-loading>
        </div>
        </div>
				<div *ngIf="btnType !== BtnType.LOADING" class="text-[12px] leading-[17.76px] font-normal text-[#333]">
					{{description}}
				</div>
			</div>
			<div *ngIf="countdown" class="pt-[12px]">
				<div class="flex flex-col gap-[8px]">
					<div class="flex items-center justify-center gap-[8px]">
						<svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M13.5241 4.89065L12.6757 4.04222L11.7943 4.9236C10.9052 4.19595 9.80483 3.71705 8.6 3.59705V2.3665H9.8V1.1665H6.2V2.3665H7.4V3.59705C4.3724 3.89946 2 6.46097 2 9.56654C2 12.875 4.69157 15.5665 8 15.5665C11.3084 15.5665 14 12.875 14 9.56654C14 8.12829 13.49 6.80654 12.6428 5.77214L13.5241 4.89065ZM9.20003 9.56654C9.20003 10.2283 8.66178 10.7665 8.00003 10.7665C7.33829 10.7665 6.80003 10.2283 6.80003 9.56654C6.80003 8.90479 7.33829 8.36654 8.00003 8.36654C8.10678 8.36654 8.20829 8.38515 8.3066 8.411L10.5758 6.14239L11.4242 6.99082L9.15503 9.25944C9.18142 9.35828 9.20003 9.4598 9.20003 9.56654Z" fill="#0361F0"/>
						</svg>
						<div class="text-[#0361F0] text-[12px] font-medium leading-[16.8px]">
							{{suspensionDescription}}
						</div>
					</div>
					<div class="bg-[#F2F7FE] items-center text-center flex gap-[10px] py-[16px] px-[24px] rounded-[8px]">
						<div class="flex flex-col grow">
							<div class="text-[#0361F0] text-[36px] font-bold leading-normal">
								{{countdown?.hours| kamonaTimeFormat}}
							</div>
							<div class="text-black text-[10px] font-medium leading-[14px]">
								Hours
							</div>
						</div>
						<div class="grow">
							<ng-container *ngTemplateOutlet="dot"></ng-container>
						</div>
						<div class="flex flex-col grow">
							<div class="text-[#0361F0] text-[36px] font-bold leading-normal">
								{{countdown?.minutes| kamonaTimeFormat}}
							</div>
							<div class="text-black text-[10px] font-medium leading-[14px]">
								Minutes
							</div>
						</div>
						<div class="grow">
							<ng-container *ngTemplateOutlet="dot"></ng-container>
						</div>
						<div class="flex flex-col grow">
							<div class="text-[#0361F0] text-[36px] font-bold leading-normal">
								{{countdown?.seconds | kamonaTimeFormat}}
							</div>
							<div class="text-black text-[10px] font-medium leading-[14px]">
								Seconds
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</ng-template>

<ng-template #footer>
	<div class="pb-[40px] pt-[24px]">
		<ng-container [ngSwitch]="btnType">
			<ng-container *ngSwitchDefault>
				<ng-container *ngTemplateOutlet="btnSecondary"></ng-container>
			</ng-container>
      <ng-container *ngSwitchCase="BtnType.LOADING">
        <ng-container *ngTemplateOutlet="loadingPrimary"></ng-container>
      </ng-container>
			<ng-container *ngSwitchCase="BtnType.PRIMARY">
				<ng-container *ngTemplateOutlet="btnPrimary"></ng-container>
			</ng-container>
			<ng-container *ngSwitchCase="BtnType.GHOST">
				<ng-container *ngTemplateOutlet="btnSecondary"></ng-container>
			</ng-container>
		</ng-container>
	</div>
</ng-template>



<ng-template #errorIcon>
	<svg width="125" height="125" viewBox="0 0 125 125" fill="none" xmlns="http://www.w3.org/2000/svg">
		<circle cx="62.5" cy="62.5" r="62.5" fill="#F8C7C7"/>
		<circle cx="62.5" cy="62.5" r="49.5" fill="#E94444"/>
		<circle cx="62.5" cy="62.5" r="38.5" fill="#BA393E"/>
		<path d="M58.5 79.5V72.5H65.5V79.5H58.5Z" fill="white"/>
		<path d="M58.5 65.5V44.5H65.5V65.5H58.5Z" fill="white"/>
	</svg>
</ng-template>
<ng-template #successIcon>
	<svg width="125" height="125" viewBox="0 0 125 125" fill="none" xmlns="http://www.w3.org/2000/svg">
		<circle cx="62.5" cy="62.5" r="62.5" fill="#BCE8C0"/>
		<circle cx="62.5" cy="62.5" r="49.5" fill="#1EB12D"/>
		<circle cx="62.5" cy="62.5" r="38.5" fill="#18902C"/>
		<path d="M43.7568 62.3746C45.0984 61.0728 47.2719 61.0708 48.6152 62.3701L54.3122 67.8796C54.7513 68.3046 55.462 68.3042 55.9011 67.8783L75.3649 48.9803C76.7149 47.67 78.9044 47.6737 80.2494 48.9885C81.5868 50.2972 81.5834 52.4098 80.2401 53.7136L58.8257 74.5046C56.7717 76.4985 53.4425 76.4985 51.3884 74.5046L43.7568 67.0956C42.4144 65.7918 42.4144 63.6783 43.7568 62.3746Z" fill="white"/>
	</svg>
</ng-template>
<ng-template #infoIcon>
	<svg width="125" height="125" viewBox="0 0 125 125" fill="none" xmlns="http://www.w3.org/2000/svg">
		<circle cx="62.5" cy="62.5" r="62.5" fill="#B3CDFA"/>
		<circle cx="62.5" cy="62.5" r="49.5" fill="#0361F0"/>
		<circle cx="62.5" cy="62.5" r="38.5" fill="#0250C8"/>
		<path d="M55.9995 66.4999V59.4651L66.5696 59.4686L66.5346 73.5002H70.0691V80.5H59.499V66.4999H55.9995Z" fill="white"/>
		<path d="M59.499 52.5667V45.5H66.5696V52.5667H59.499Z" fill="white"/>
	</svg>
</ng-template>

<ng-template #warningIcon>
  <svg width="125" height="125" viewBox="0 0 125 125" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="62.5" cy="62.5" r="62.5" fill="#FBDCBD"/>
    <circle cx="62.5" cy="62.5" r="49.5" fill="#F08922"/>
    <circle cx="62.5" cy="62.5" r="38.5" fill="#C07023"/>
    <path d="M55.9995 66.4999V59.4651L66.5696 59.4686L66.5346 73.5002H70.0691V80.5H59.499V66.4999H55.9995Z" fill="white"/>
    <path d="M59.499 52.5667V45.5H66.5696V52.5667H59.499Z" fill="white"/>
  </svg>
</ng-template>

<ng-template #btnPrimary>
	<div (click)="dismiss()" class="cursor-pointer h-[48px] items-center flex justify-center bg-[#0361F0] rounded-[8px] py-[6px] px-[16px]">
		<div class="text-[14px] leading-[17.36px] font-medium text-white">
			{{btnText}}
		</div>
	</div>
</ng-template>

<ng-template #loadingPrimary>
  <div class="h-[48px] items-center flex justify-center py-[6px] px-[16px] relative">
  </div>
</ng-template>
<ng-template #btnSecondary>
	<div (click)="dismiss()" class="cursor-pointer h-[48px] items-center flex justify-center bg-[#0357EE]/10 rounded-[8px] py-[6px] px-[16px]">
		<div class="text-[14px] leading-[17.36px] font-medium text-[#0361F0]">
			{{btnText}}
		</div>
	</div>
</ng-template>

<ng-template #dot>
	<svg width="6" height="23" viewBox="0 0 6 23" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M0.146973 19.6562C0.146973 18.9271 0.394368 18.3151 0.88916 17.8203C1.38395 17.3125 2.05452 17.0586 2.90088 17.0586C3.76025 17.0586 4.43083 17.3125 4.9126 17.8203C5.40739 18.3151 5.65479 18.9271 5.65479 19.6562C5.65479 20.3854 5.40739 20.9974 4.9126 21.4922C4.43083 21.987 3.76025 22.2344 2.90088 22.2344C2.05452 22.2344 1.38395 21.987 0.88916 21.4922C0.394368 20.9974 0.146973 20.3854 0.146973 19.6562ZM0.166504 3.01562C0.166504 2.28646 0.4139 1.67448 0.908691 1.17969C1.40348 0.671875 2.07406 0.417969 2.92041 0.417969C3.77979 0.417969 4.45036 0.671875 4.93213 1.17969C5.42692 1.67448 5.67432 2.28646 5.67432 3.01562C5.67432 3.74479 5.42692 4.35677 4.93213 4.85156C4.45036 5.34635 3.77979 5.59375 2.92041 5.59375C2.07406 5.59375 1.40348 5.34635 0.908691 4.85156C0.4139 4.35677 0.166504 3.74479 0.166504 3.01562Z" fill="#B6C1D6"/>
	</svg>
</ng-template>
